import React, { useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';
import { FormatNumber } from 'src/utils';

const LineColumnApexChart = ({ title, series = [], categories = [], symbol = '' }) => {
    const { t } = useTranslation();
    useEffect(() => {
        console.log('chartCategories:: ', categories);
        console.log('series:: ', series);
    }, [categories, series]);

    const chartOptions = {
        series: series,
        options: {
            chart: {
                height: 400,
                type: 'line',
                zoom: {
                    enabled: false, // Tắt chức năng zoom
                },
                stacked: false,
            },
            stroke: {
                width: [0, 4, 4, 4], // Đặt độ dày cho từng loại series (đường viền cho các series dạng line)
            },
            title: {
                text: title,
                // floating: true,
                // offsetY: 330,
                // align: 'center',
                style: {
                    color: '#444',
                },
            },
            fill: {
                opacity: [0.85, 0.25, 1],
                gradient: {
                    inverseColors: false,
                    shade: 'light',
                    type: 'vertical',
                    opacityFrom: 0.85,
                    opacityTo: 0.55,
                    stops: [0, 100, 100, 100],
                },
            },
            dataLabels: {
                // enabledOnSeries: [1, 3], // Hiển thị nhãn chỉ trên dòng
                enabled: false,
                // enabledOnSeries: [1],
                formatter: function (val) {
                    return FormatNumber(val);
                },
                offsetY: -20,
                style: {
                    fontSize: '12px',
                    colors: ['#304758'],
                },
            },
            labels: categories,
            xaxis: {
                categories: categories,
                position: 'bottom',
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: true,
                },
            },
            plotOptions: {
                bar: {
                    columnWidth: '50%',
                },
            },
            yaxis: [
                {
                    seriesName: [
                        t('expense') + ` (${t('department')})` ,
                        t('expense') + ` (${t('factory')})`  ,
                        t('expense') + ` (${t('staff')})`,
                    ],
                    title: {
                        text: t('expense') + " " + symbol,
                    },
                    min: 0,
                    labels: {
                        formatter: function (val) {
                            return new Intl.NumberFormat().format(val);
                            return FormatNumber(val); // Format lại số chi phí
                        },
                    },
                },
                // {
                //     seriesName: 'Chi phí (Bộ phận)',
                //     show: false,
                // },
                {
                    seriesName: [
                        t('amount') + ` (${t('department')}) `,
                        t('amount') + ` (${t('factory')})`,
                        t('amount') + ` (${t('staff')})`,
                    ],
                    opposite: true,
                    title: {
                        text: t('amount') + ' (' + t('unitPcs') + ')',
                    },
                    min: 0,
                    labels: {
                        formatter: function (val) {
                            return new Intl.NumberFormat().format(val);
                            return FormatNumber(val); // Format lại số lượng
                        },
                    },
                    // Sử dụng hệ thống tự động chia tỷ lệ trục y
                    // logarithmic: true, // Dùng tỷ lệ logarithmic để cân bằng sự chênh lệch giữa số lượng và chi phí
                },
            ],
        },
    };

    return (
        <div>
            <div id="chart">
                <ReactApexChart options={chartOptions.options} series={chartOptions.series} type="line" height={350} />
            </div>
            <div id="html-dist"></div>
        </div>
    );
};

export default LineColumnApexChart;
